/*
  Keeps the Pre-Order wording in step with the selected variant.
  The variant picker (VariantSelects in global.js) re-renders the product section for the newly chosen variant and
  publishes PUB_SUB_EVENTS.variantChange with the fetched document. Copy every [data-variant-sync] fragment from it.
*/
(function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    var html = event && event.data && event.data.html;
    if (!html) return;
    document.querySelectorAll('[data-variant-sync]').forEach(function (target) {
      var source = target.id ? html.getElementById(target.id) : null;
      if (source) target.innerHTML = source.innerHTML;
    });
  });
})();
